import styled from "styled-components";
import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faHourglassStart,
  faDoorOpen,
  faUtensils,
  faUser,
  faEquals,
  faHourglassEnd,
  faPowerOff,
  faX,
  faXmark,
  faTable,
  faCircle,
  faChair,
} from "@fortawesome/free-solid-svg-icons";
import { faFreebsd } from "@fortawesome/free-brands-svg-icons";

export const ContainerBox = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  background-color: #f0ebe0;
  border-radius: 5px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #99b0ad;
  color: white;
  border-radius: 5px 5px 0 0;
`;

export const Body = styled.div`
  height: 300px;
  overflow-y: auto;
  padding: 0px 10px 0px 10px;
  /* Style the scrollbar */
  &::-webkit-scrollbar {
    width: 8px; /* Scrollbar width */
    padding-bottom: 10px !important;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* Light gray track */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Darker gray thumb */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Slightly darker on hover */
  }
`;

export const OrangeButton = styled.button`
  padding: 8px 11px;
  background-color: #ee754c;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ee561b;
  }
`;

export const Title = styled.h4`
  margin: 0;
  font-weight: 500;
  color: white;
`;

export const Container = styled.div`
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 30px;
  padding-top: 60px;
  @media (max-width: 768px) {
    padding: 0px;
    padding-top: 0;
    margin: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  height: 30px;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #faf6e9;
  color: white;
  border-radius: 5px;
  margin-bottom: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const CardHeaderTitle = styled.h4`
  margin: 0;
  font-weight: 600;
  color: #ee754c;
  font-size: 20px;
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
  width: 100%;
`;

export const InsideFormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`;

export const Input = styled.input`
  padding: 4px 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  width: 60px;
  transition: border 0.2s ease-in-out;
  color: #99b0ad;

  &:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 2px rgba(230, 187, 69, 0.2);
  }
`;

export const InlineText = styled.span`
  margin: 0 6px;
  font-size: 14px;
  color: #99b0ad;
`;

export const StyledLabel = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
  margin-bottom: 1px;
  margin-top: 15px;
`;
export const StyledInput = styled.input`
  width: 100%;
  padding: 14px 18px;
  font-size: 16px;
  border: 1px solid #ddd;
  margin-bottom: 1rem;
  border-radius: 10px;
  background-color: #fafafa;
  transition: all 0.2s ease;

  &:focus {
    border-color: #de8c3a;
    background-color: #fff;
    box-shadow: 0 0 0 4px rgba(222, 140, 58, 0.15);
    outline: none;
  }

  &::placeholder {
    color: #aaa;
  }
`;

/* interface FormattedDateProps {
  date: Date | string;
}

export const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  const parsedDate = new Date(date);

  const weekday = parsedDate.toLocaleDateString("pt-PT", { weekday: "short" });
  const day = parsedDate.getDate().toString().padStart(2, "0");
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
  const year = parsedDate.getFullYear();

  return <>{`${weekday}, ${day}-${month}-${year}`}</>;
};
 */

export const ButtonGap = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  font-size: ${({ $fontSize }) => $fontSize || "14px"};
  font-weight: 500;
  cursor: pointer;
  background-color: ${({ $color }) => $color || "#007bff"};
  color: white;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;


  white-space: nowrap; 
  flex: 0 0 auto; 

  &:hover {
    background-color: ${({ $color }) => darkenColor($color || "#007bff", 0.1)};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    background-color: #ccc !important;
    color: #666;
    cursor: not-allowed !important;
    box-shadow: none;
  }


  @media (max-width: 576px) {
    padding: 6px 10px; /
    font-size: 12px;
    min-height: 42px;
    border-radius: 8px;
  }
`;

// Helper function to darken the hover color
function darkenColor(hex, amount) {
  try {
    let col = hex;
    if (col.startsWith("#")) col = col.slice(1);

    const num = parseInt(col, 16);
    let r = (num >> 16) - amount * 255;
    let g = ((num >> 8) & 0x00ff) - amount * 255;
    let b = (num & 0x0000ff) - amount * 255;

    r = Math.max(0, r);
    g = Math.max(0, g);
    b = Math.max(0, b);

    return `rgb(${r}, ${g}, ${b})`;
  } catch {
    return hex;
  }
}

export const ModernButton = ({
  children,
  color,
  fontSize,
  onClick,
  style,
  type = "button",
  disabled = false,
}) => {
  return (
    <StyledButton
      $color={color}
      onClick={onClick}
      style={style}
      $fontSize={fontSize}
      type={type}
      disabled={disabled}
    >
      {children}
    </StyledButton>
  );
};

//DATE FORMAT: Sábado, 19 de Abril de 2025
export const DefaultDateExtended = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    const weekday = d.toLocaleDateString("pt-PT", { weekday: "long" });
    const day = d.getDate().toString().padStart(2, "0");
    const month = d.toLocaleDateString("pt-PT", { month: "long" });
    const year = d.getFullYear();

    return `${weekday}, ${day} de ${month} de ${year}`;
  };

  return <>{formatDate(date)}</>;
};

//DATE FORMAT: Sáb, 19-04-2025
export const DefaultDate = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    let weekday = d
      .toLocaleDateString("pt-PT", { weekday: "long" })
      .slice(0, 3);
    weekday = weekday.charAt(0).toLowerCase() + weekday.slice(1);

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    return `${weekday}, ${day}/${month}/${year}`;
  };

  return <>{formatDate(date)}</>;
};

export const DefaultDateUpper = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    let weekday = d
      .toLocaleDateString("pt-PT", { weekday: "long" })
      .slice(0, 3);

    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    return `${weekday}, ${day}/${month}/${year}`;
  };

  return <>{formatDate(date)}</>;
};

//DATE FORMAT: 19/04/2025
export const DefaultDateSmall = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return <>{formatDate(date)}</>;
};

//DATE FORMAT: 19/04/2025, 14:32
export const DefaultDateSmallMins = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    const hours = d.getHours().toString().padStart(2, "0");
    const minutes = d.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}:${minutes}`;
  };

  return <>{formatDate(date)}</>;
};

export const ErrorMessageBox = styled.div`
  background-color: #ffeded;
  color: #b00020;
  border-left: 5px solid #b00020;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 20px;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CloseIcon = styled(FontAwesomeIcon).attrs({ icon: faXmark })`
  position: absolute;
  right: 22px;
  font-size: 30px;
  color: #faf6e9;
  cursor: pointer;
  transition: color 0.2s ease;
`;

export const CustomModal = styled(({ className, ...props }) => (
  <Modal {...props} className={className} backdrop="static" />
))`
  .modal-dialog {
    max-width: 505px;
    margin: 20px auto;
  }

  .modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  }

  .modal-header {
    background-color: #ee754c;
    border: none;
    padding: 1rem 1.5rem;
  }

  .modal-title {
    font-weight: bold;
    font-size: 20px;
    color: #faf6e9;
  }

  .modal-body {
    padding: 1.5rem;
    overflow: auto;
  }

  .modal-footer {
    background-color: white;
    border: none;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 576px) {
    .modal-body {
      padding: 0.75rem;
    }
  }
`;
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(33, 33, 33, 0.5);
  z-index: 1040;
`;

export const ConfirmationModal = styled(({ className, ...props }) => (
  <Modal {...props} className={className} backdrop="static" />
))`
  .modal-dialog {
    max-width: 400px;
    z-index: 1500 !important;
  }

  .modal-content {
    border-radius: 7px;
    border: none;
    box-shadow: 0 12px 52px rgba(0, 0, 0, 0.1);
  }

  .modal-header {
    background-color: #ee754c;
    border: none;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }

  .modal-title {
    font-weight: bold;
    font-size: 20px;
    color: white;
  }
`;

export const ModernTextInput = styled.input.attrs({
  type: "text",
})`
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  background-color: #fff;
  color: #333;

  &:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 3px rgba(238, 117, 76, 0.2);
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const statusToGroup = {
  accepted: "A CHEGAR",
  Accepted_edit: "A CHEGAR",
  Rejected_edition: "A CHEGAR",
  Accepted_With_Table: "A CHEGAR",
  Accepted_Without_Table: "A CHEGAR",
  waiting_list: "À PORTA",
  pending_restaurant: "REST",
  edited: "REST",
  pending_customer: "CLIENTE",
  late: "ATRASADA",
  attended: "FINALIZADA",
  completed: "Mesa livre",
  no_show: "CANCELADAS",
  cancelled_customer: "CANCELADAS",
  cancelled_restaurant: "CANCELADAS",
  Cancelled: "CANCELADAS",
};

export const iconStatusMap = {
  "A CHEGAR": {
    icon: faHourglassStart,
    label: "Confirmada",
  },
  ATRASADA: { icon: faHourglassEnd, label: "Atrasadas" },
  "À PORTA": { icon: faDoorOpen, label: "Na fila à porta" },
  REST: { icon: faUtensils, label: "A aguardar aceitação do restaurante" },
  CLIENTE: { icon: faUser, label: "Aguarda reconfirmação do cliente" },
  FINALIZADA: { icon: faChair, label: "Mesa ocupada" },
  "Mesa livre": { icon: faCircle, label: "Mesa livre" },
  CANCELADAS: { icon: faX, label: "Canceladas" },
  TOTAL: { icon: faEquals, label: "Total" },
};

export const labelColors = {
  "A CHEGAR": "#5E9C7C",
  "À PORTA": "#5E9C7C",
  REST: "#d9b645",
  CLIENTE: "#d9b645",
  ATRASADA: "#ba6f32",
  FINALIZADA: "#0fa644",
  "Mesa livre": "#0fa644",
  CANCELADAS: "#822839",
};

export const statusGroups = {
  "A CHEGAR": [
    "accepted",
    "Accepted_edit",
    "Rejected_edition",
    "Accepted_With_Table",
    "Accepted_Without_Table",
  ],
  "À PORTA": ["waiting_list"],
  REST: ["pending_restaurant", "edited"],
  CLIENTE: ["pending_customer"],
  ATRASADA: ["late"],
  FINALIZADA: ["attended"],
  CANCELADAS: [
    "no_show",
    "cancelled_customer",
    "cancelled_restaurant",
    "Cancelled",
  ],
  "Mesa livre": ["completed"],
};

// Container for grouped sections (cards)
export const SettingsCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// Section title styling
export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
`;

// Default paragraph-like text
export const Text = styled.span`
  font-size: 14px;
  color: #6c757d;
  display: block;
  margin-bottom: 16px;
  margin-top: 4px;
  line-height: 1.4;
`;

// Responsive grid layout for wrapping cards
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0px 5px;
  height: auto;

  @media (max-width: 768px) {
    padding-top: 0px;
    margin-top: 0px;
    justify-content: center;
  }
`;

// Inline spacing element used for layout adjustments
export const CustomSpan = styled.span`
  margin: 0 8px;
  display: inline-block;
`;

// Reusable select with focus & hover styles
export const StyledSelect = styled.select`
  width: auto;
  min-width: 140px;
  height: 40px;
  font-size: 14px;
  padding: 0 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  color: #333;
  outline: none;
  appearance: none;
  cursor: pointer;

  &:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.25);
  }

  &:hover {
    border-color: #ee754c;
  }
`;
// Container for password input and icon
export const PasswordContainer = styled.div`
  position: relative;
`;

// Password input with space for toggle icon
export const StyledPasswordInput = styled(StyledInput)`
  padding-right: 40px;
`;

// Toggle icon for show/hide password
export const PasswordToggleIcon = styled.div`
  position: absolute;
  top: 40%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;

  svg {
    font-size: 18px;
    color: #ee754c;
  }
`;
